let env = window && window.env ? window.env : process.env

env = Object.assign(env, {
  REACT_APP_FAA_CRM_INTEGRATION_TOGGLE: env.REACT_APP_FAA_CRM_INTEGRATION_TOGGLE || 'on',
  REACT_APP_SEND_NOTIFICATION_ENDPOINT: env.REACT_APP_SEND_NOTIFICATION_ENDPOINT || 'https://corp-api.qa.foundationmedicine.com/api/v2/send-notification',
  REACT_APP_CORP_URL: env.REACT_APP_CORP_URL || 'http://localhost:4008',
  REACT_APP_EXTERNAL_URL: env.REACT_APP_EXTERNAL_URL || 'http://localhost:8087',
  REACT_APP_KEEPALIVE_TIMEOUT: env.REACT_APP_KEEPALIVE_TIMEOUT || 300000,
})

export default env
